// src/lib/pendingCheckout.js
//
// Remembers what someone was buying across the signup/login/onboarding
// detour, so a click on a techbugz.com "Get started" button survives account
// creation. Stored as the checkout query — "plan=google_essentials" (preferred,
// works in test and live mode) or "price=price_…" (older links). See
// src/pages/Checkout.js for where this is set, AuthScreen.js / Onboarding.js
// for where it's consumed.
const KEY = "pendingCheckoutPriceId";

const asQuery = v => (!v ? null : v.startsWith("price_") ? `price=${encodeURIComponent(v)}` : v);

export function setPendingCheckout(query) {
  sessionStorage.setItem(KEY, query);
}

export function popPendingCheckout() {
  const v = sessionStorage.getItem(KEY);
  sessionStorage.removeItem(KEY);
  return asQuery(v);
}

export function pendingCheckoutRedirect() {
  const q = asQuery(sessionStorage.getItem(KEY)); // peek, don't clear — Checkout.js clears it once it actually fires
  return q ? `/checkout?${q}` : null;
}
